import { useAuth0 } from "@auth0/auth0-react";
import { ComponentProps } from "react";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@punto/ui/components/avatar";

const UserAvatar = (props: ComponentProps<typeof Avatar>) => {
  const { user } = useAuth0();

  return (
    <Avatar {...props}>
      <AvatarImage src={user?.picture} />
      <AvatarFallback>
        {user?.given_name?.charAt(0)}
        {user?.family_name?.charAt(0)}
      </AvatarFallback>
    </Avatar>
  );
};

export { UserAvatar };
